import React from 'react'
import CustomMenu from "../CustomMenu/index";
import image from '../../images/favicon.ico'
import cookie from 'react-cookies'
/**
 * 侧边栏路径映射
 * @type {({icon: string, title: string, key: string}|{icon: string, title: string, key: string}|{subs: [{icon: string, title: string, key: string}, {icon: string, title: string, key: string}, {icon: string, title: string, key: string}], icon: string, title: string, key: string}|{icon: string, title: string, key: string}|{icon: string, title: string, key: string})[]}
 */
const menus =  [

  {
    title: '首页',
    icon: 'home',
    key: '/home'
  },
  {
    title: '报警规则',
    icon: 'setting',
    key: '/home/alerts/rules',
  },
  // {
  //   title: '监控指标',
  //   icon: 'bars',
  //   key: '/home/alerts/metrics/db',
  // },
  {
    title: '警报信息',
    icon: 'bell',
    key: '/home/alerts',
    subs: [
      {key: '/home/alerts/unhandled-alerts', title: '正在报警', icon: '',},
      {key: '/home/alerts/handled-alerts', title: '历史报警', icon: '',}
    ]
  },
  {
    title: '订阅报警',
    icon: 'edit',
    key: '/home/alerts/subscribing',
  },
  {
    title: '用户信息',
    icon: 'user',
    key: '/home/users'
  },
  {
    title: '监控可视化信息',
    icon: 'line-chart',
    key: '/home/monitor/dashboard/metric'
  },
] 


class SiderNav extends React.Component {
  render() {
    return (
      <div style={{height: '100vh',overflowY:'scroll'}}>
        <div style={styles.logo}><img src={image} width='35px' />&nbsp;监控报警系统</div>
        <CustomMenu menus={menus}/>
      </div>
    )
  }
}

const styles = {
  logo: {
    fontSize: '15px',
    color: 'white',
    image: image,
    height: '32px',
    margin: '16px',
  }
}

export default SiderNav


// WEBPACK FOOTER //
// ./src/components/SiderNav/index.js